export default __webpack_public_path__ + "static/media/publicSpeakingCardImg.a37a6d52.png";